import React from 'react'
import PropTypes from 'prop-types'
import Share from '@assets/images/share.png'
import styles from './index.module.scss'

const Guidance = ({ close }) => {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div className={styles.mask} onClick={close}>
      <span>
        <img src={Share} alt="" />
      </span>
      <span>点击这里，收藏不迷路</span>
    </div>
  )
}

Guidance.defaultProps = {
  close: () => {}
}
Guidance.propTypes = {
  close: PropTypes.func
}

export default Guidance
